import React from 'react';
import {Row, Col} from 'reactstrap';
import img1 from '../../../assets/images/frontpage/26114210_1406381776156172_758146053707035878_n.jpg';
import img2 from '../../../assets/images/frontpage/IMG_0405.jpg';
import img3 from '../../../assets/images/frontpage/IMG_0288.jpg';
import img4 from '../../../assets/images/frontpage/IMG_0271.jpg';

const images = () => {
    const imgs = [
        img1,
        img2,
        img3,
        img4
    ];

    let content = imgs.map(img => {
       return(
           <Col xs='6' key={Math.random()}>
            <img className='frontpage-promo-images' src={img} alt="something"/>
           </Col>
       )
    });

    return(
        <Row>
            {content}
        </Row>
    )
};

export default images;


// WEBPACK FOOTER //
// ./src/containers/Homepage/Images/Images.js